/* SKANDILUX sections — vanilla JS, no dependencies */
(function () {
  if (window.__skxLoaded) return; window.__skxLoaded = true;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- money ---------- */
  function money(cents, fmt) {
    fmt = fmt || '{{amount}} kr';
    const v = (cents || 0) / 100;
    const fix = (n, d, t, dec) => {
      const p = n.toFixed(d).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return p.join(dec);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: fix(v, 2, ',', '.'),
      amount_no_decimals: fix(v, 0, ',', '.'),
      amount_with_comma_separator: fix(v, 2, '.', ','),
      amount_no_decimals_with_comma_separator: fix(v, 0, '.', ','),
      amount_with_space_separator: fix(v, 2, ' ', ','),
      amount_no_decimals_with_space_separator: fix(v, 0, ' ', ','),
      amount_with_apostrophe_separator: fix(v, 2, "'", '.')
    }[k] || fix(v, 2, ',', '.')));
  }

  /* ---------- compare slider ---------- */
  function initCompare(root) {
    root.querySelectorAll('[data-skx-compare]').forEach(c => {
      const r = c.querySelector('input');
      r && r.addEventListener('input', () => c.style.setProperty('--pos', r.value + '%'));
    });
  }

  /* ---------- dimmer demo ---------- */
  function initDimmer(root) {
    root.querySelectorAll('[data-skx-dimmer]').forEach(w => {
      const img = w.querySelector('.skx-dimmer img'), box = w.querySelector('.skx-dimmer');
      const range = w.querySelector('input[type=range]'), val = w.querySelector('.skx-dim-val'), tg = w.querySelector('.skx-toggle');
      if (!img || !range) return;
      const L = { on: tg.dataset.on || 'Släck', off: tg.dataset.off || 'Tänd', zero: tg.dataset.zero || 'Av' };
      let on = true;
      const render = () => {
        const v = on ? range.value / 100 : 0;
        img.style.filter = 'brightness(' + (0.18 + 0.92 * v).toFixed(2) + ') saturate(' + (0.6 + 0.5 * v).toFixed(2) + ')';
        box.style.setProperty('--veil', (0.95 - 0.85 * v).toFixed(2));
        val.textContent = on ? range.value + '%' : L.zero;
        tg.textContent = on ? L.on : L.off;
        tg.setAttribute('aria-pressed', on);
      };
      range.addEventListener('input', () => { on = true; render(); });
      tg.addEventListener('click', () => { on = !on; render(); });
      box.addEventListener('click', () => { on = !on; render(); });
      render();
    });
  }

  /* ---------- anatomy finish dots ---------- */
  function initDots(root) {
    root.querySelectorAll('[data-skx-dots]').forEach(d => {
      const img = document.getElementById(d.dataset.skxDots), name = d.querySelector('small');
      d.querySelectorAll('button').forEach(b => b.addEventListener('click', () => {
        if (img && b.dataset.src) img.src = b.dataset.src;
        if (name) name.textContent = b.dataset.name || '';
        d.querySelectorAll('button').forEach(x => x.setAttribute('aria-pressed', x === b));
      }));
    });
  }

  /* ---------- cart drawer (shared) ---------- */
  const Cart = {
    el: null, cfg: null, product: null, lastFocus: null,
    ensure(cfg, product) {
      this.cfg = cfg; this.product = product;
      this.el = document.getElementById('skx-drawer');
      if (!this.el) return false;
      if (this.el.dataset.bound) return true;
      this.el.dataset.bound = '1';
      const close = () => this.close();
      this.el.querySelectorAll('[data-skx-close]').forEach(b => b.addEventListener('click', close));
      document.getElementById('skx-scrim').addEventListener('click', close);
      document.addEventListener('keydown', e => { if (e.key === 'Escape' && this.el.classList.contains('open')) close(); });
      return true;
    },
    async add(items) {
      const r = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message || 'Kunde inte lägga till');
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      return j;
    },
    async change(key, quantity) {
      await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      this.render();
    },
    async render() {
      const cart = await (await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      const fmt = this.cfg.moneyFormat, el = this.el;
      const lines = el.querySelector('[data-skx-lines]');
      lines.innerHTML = '';
      if (!cart.items.length) lines.innerHTML = '<p class="skx-empty">' + (this.cfg.t.empty || 'Varukorgen är tom.') + '</p>';
      const orderDisc = (cart.cart_level_discount_applications || []).reduce((a, d) => a + (d.total_allocated_amount || 0), 0);
      const sub = cart.items_subtotal_price || 0;
      cart.items.forEach(it => {
        const row = document.createElement('div'); row.className = 'skx-line';
        const share = orderDisc && sub ? Math.round(orderDisc * it.final_line_price / sub) : 0;
        const now = it.final_line_price - share, was = it.original_line_price;
        const img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
        row.innerHTML = '<img src="' + img + '" alt=""><div><b></b><small></small><div class="skx-qty"><button aria-label="−">−</button><span>' + it.quantity + '</span><button aria-label="+">+</button></div></div><div class="skx-lp">' + (was > now ? '<s>' + money(was, fmt) + '</s>' : '') + '<b>' + money(now, fmt) + '</b></div>';
        row.querySelector('div b').textContent = it.product_title;
        row.querySelector('div small').textContent = it.variant_title || '';
        const [m, p] = row.querySelectorAll('.skx-qty button');
        m.addEventListener('click', () => this.change(it.key, it.quantity - 1));
        p.addEventListener('click', () => this.change(it.key, it.quantity + 1));
        lines.appendChild(row);
      });
      el.querySelector('[data-skx-total]').textContent = money(cart.total_price, fmt);
      let sv = el.querySelector('[data-skx-dsave]');
      if (!sv) {
        const tot = el.querySelector('.skx-dr-total');
        sv = document.createElement('div'); sv.className = 'skx-dr-save'; sv.setAttribute('data-skx-dsave', ''); sv.innerHTML = '<span></span><b></b>';
        tot && tot.parentNode.insertBefore(sv, tot);
        const st = document.createElement('style');
        st.textContent = '.skx-lp{text-align:right;display:grid;gap:2px}.skx-lp s{font-size:13px;color:var(--text-2)}.skx-dr-save{display:flex;justify-content:space-between;align-items:center;font-size:14px;color:var(--honey);margin-bottom:6px}.skx-dr-save[hidden]{display:none}.skx-dr-save b{font-weight:600}';
        document.head.appendChild(st);
      }
      const saved = cart.original_total_price - cart.total_price;
      if (sv) { sv.hidden = !(saved > 0); const apps = (cart.cart_level_discount_applications || []).concat(cart.items.flatMap(i => (i.line_level_discount_allocations || []).map(a => a.discount_application))); sv.querySelector('span').textContent = (apps[0] && apps[0].title) || 'Paketrabatt'; sv.querySelector('b').textContent = '−' + money(saved, fmt); }
      setFreeShip(cart.total_price, this.cfg);
      /* recommendations: other variants of this product that are not in the cart */
      const recWrap = el.querySelector('[data-skx-recs]'), grid = el.querySelector('[data-skx-recs-grid]');
      grid.innerHTML = '';
      const inCart = new Set(cart.items.map(i => i.variant_id));
      (this.product ? this.product.variants : []).filter(v => v.available && !inCart.has(v.id)).slice(0, 2).forEach(v => {
        const c = document.createElement('div'); c.className = 'skx-rec';
        c.innerHTML = '<img src="' + (v.image || '') + '" alt=""><b></b><small>' + money(v.price, fmt) + '</small><button type="button">' + (this.cfg.t.add || 'Lägg till') + '</button>';
        c.querySelector('b').textContent = v.title;
        c.querySelector('button').addEventListener('click', async () => { await this.add([{ id: v.id, quantity: 1 }]); this.render(); });
        grid.appendChild(c);
      });
      recWrap.hidden = !grid.children.length;
    },
    async open() {
      this.lastFocus = document.activeElement;
      await this.render();
      this.el.classList.add('open'); document.getElementById('skx-scrim').classList.add('open');
      this.el.setAttribute('aria-hidden', 'false');
      const x = this.el.querySelector('[data-skx-close]'); x && x.focus();
    },
    close() {
      this.el.classList.remove('open'); document.getElementById('skx-scrim').classList.remove('open');
      this.el.setAttribute('aria-hidden', 'true');
      this.lastFocus && this.lastFocus.focus();
    }
  };

  function setFreeShip(total, cfg) {
    const th = cfg.freeShip || 0, left = Math.max(th - total, 0);
    const pct = th > 0 ? Math.min(total / th, 1) * 100 : 0;
    const txt = th > 0 && left === 0 ? cfg.t.fsDone : cfg.t.fsLeft.replace('[amount]', '<b>' + money(left, cfg.moneyFormat) + '</b>');
    document.querySelectorAll('[data-skx-fs-text]').forEach(e => e.innerHTML = txt);
    document.querySelectorAll('[data-skx-fs-fill]').forEach(e => e.style.width = pct + '%');
  }

  /* ---------- product main ---------- */
  function initProduct(root) {
    root.querySelectorAll('[data-skx-product]').forEach(sec => {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      const data = JSON.parse(sec.querySelector('script[data-skx-json]').textContent);
      const cfg = data.cfg, variants = data.variants;
      let vIdx = Math.max(0, variants.findIndex(v => v.id === data.selected));
      const tiers = [...sec.querySelectorAll('.skx-tier')];
      let tier = Math.max(0, tiers.findIndex(t => t.dataset.default === '1'));
      let units = [];
      const q = s => sec.querySelector(s);

      /* gallery */
      const slides = [...sec.querySelectorAll('.skx-gslide')], thumbs = [...sec.querySelectorAll('.skx-thumbs button')];
      function show(i) {
        slides.forEach((s, j) => {
          s.classList.toggle('is-active', j === i);
          const vid = s.querySelector('video');
          if (vid) { if (j === i && !reduce) { const p = vid.play(); p && p.catch && p.catch(() => {}); } else vid.pause(); }
        });
        thumbs.forEach((t, j) => t.setAttribute('aria-current', j === i));
      }
      thumbs.forEach((t, i) => t.addEventListener('click', () => show(i)));
      show(0);

      /* variant + tier rendering */
      /* per-lamp finish pickers inside the selected tier */
      function tierPrice(t, v) {
        const n = +t.dataset.qty;
        return { n, now: t.dataset.price ? +t.dataset.price : v.price * n, was: t.dataset.compare ? +t.dataset.compare : (v.compare_at_price || 0) * n };
      }
      function buildUnits() {
        tiers.forEach((t, i) => {
          const box = t.querySelector('[data-units]'); if (!box) return;
          box.innerHTML = '';
          if (i !== tier || variants.length < 2) return;
          const n = +t.dataset.qty;
          while (units.length < n) units.push(vIdx);
          units.length = n;
          for (let u = 0; u < n; u++) {
            const row = document.createElement('div'); row.className = 'skx-unit';
            const img = document.createElement('img'); img.alt = '';
            const sel = document.createElement('select'); sel.setAttribute('aria-label', (cfg.t.unit || 'Lampa') + ' ' + (u + 1));
            variants.forEach((vv, k) => { const o = document.createElement('option'); o.value = k; o.textContent = vv.title + (vv.available ? '' : ' – ' + cfg.t.soldout); o.disabled = !vv.available; sel.appendChild(o); });
            sel.value = units[u];
            const set = () => { img.src = variants[units[u]].image || ''; };
            set();
            sel.addEventListener('click', e => e.stopPropagation());
            sel.addEventListener('change', () => {
              units[u] = +sel.value; set(); vIdx = units[0]; render(false);
              const mid = variants[units[u]].media_id, si = slides.findIndex(sl => +sl.dataset.mediaId === mid); if (si > -1) show(si);
            });
            const lab = document.createElement('span'); lab.textContent = n > 1 ? (cfg.t.unit || 'Lampa') + ' ' + (u + 1) : (cfg.t.finish || 'Finish');
            row.append(img, lab, sel); box.appendChild(row);
          }
        });
      }
      function render(rebuild) {
        const v = variants[vIdx], qty = tiers.length ? +tiers[tier].dataset.qty : 1;
        if (rebuild !== false) buildUnits();
        sec.querySelectorAll('.skx-swatch').forEach((s, i) => s.setAttribute('aria-checked', i === vIdx));
        const nm = q('[data-skx-vname]'); if (nm) nm.textContent = v.title;
        const tp = tiers.length ? tierPrice(tiers[tier], v) : { now: v.price, was: v.compare_at_price || 0 };
        const now = tp.now, was = tp.was;
        q('[data-skx-price]').textContent = money(now, cfg.moneyFormat);
        const w = q('[data-skx-was]'), sv = q('[data-skx-save]');
        w.hidden = sv.hidden = !(was > now);
        w.textContent = money(was, cfg.moneyFormat);
        sv.textContent = cfg.t.save.replace('[amount]', money(was - now, cfg.moneyFormat));
        tiers.forEach((t, i) => {
          t.setAttribute('aria-checked', i === tier);
          const p = tierPrice(t, v);
          t.querySelector('[data-tier-price]').textContent = money(p.now, cfg.moneyFormat);
          const tw = t.querySelector('[data-tier-was]');
          tw.textContent = p.was > p.now ? money(p.was, cfg.moneyFormat) : '';
          const bd = t.querySelector('[data-tier-badge]');
          if (bd) { const pc = p.was > p.now ? Math.round((1 - p.now / p.was) * 100) : 0; bd.hidden = !pc; bd.textContent = (cfg.t.off || '[pct]% rabatt').replace('[pct]', pc); }
        });
        /* stock urgency from real inventory */
        const st = q('[data-skx-stock]');
        if (st) {
          const inv = v.inventory_quantity, show = v.tracked && v.available && inv > 0 && inv <= cfg.stockThreshold;
          st.hidden = !show;
          if (show) {
            st.querySelector('[data-skx-stock-n]').textContent = inv;
            st.querySelector('.skx-stock-bar i').style.width = Math.max(8, inv / cfg.stockThreshold * 100) + '%';
          }
        }
        const atc = q('[data-skx-atc]');
        atc.disabled = !v.available;
        atc.querySelector('span').textContent = v.available ? cfg.t.atc : cfg.t.soldout;
        const sImg = document.querySelector('[data-skx-sticky-img]'); if (sImg && v.image) sImg.src = v.image;
        const sMeta = document.querySelector('[data-skx-sticky-meta]'); if (sMeta) sMeta.textContent = v.title + ' · ' + money(now, cfg.moneyFormat);
        const input = q('input[name=id]'); if (input) input.value = v.id;
        if (cfg.updateUrl && history.replaceState) {
          const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
        }
      }
      sec.querySelectorAll('.skx-swatch').forEach((s, i) => s.addEventListener('click', () => {
        vIdx = i; render();
        const mid = variants[i].media_id;
        const si = slides.findIndex(sl => +sl.dataset.mediaId === mid);
        if (si > -1) show(si);
      }));
      tiers.forEach((t, i) => t.addEventListener('keydown', e => { if ((e.key === 'Enter' || e.key === ' ') && e.target === t) { e.preventDefault(); t.click(); } }));
      tiers.forEach((t, i) => t.addEventListener('click', e => { if (e.target.closest('select')) return; if (tier !== i) { tier = i; render(); } }));
      document.querySelectorAll('[data-skx-pick-tier]').forEach(b => b.addEventListener('click', () => {
        const i = +b.dataset.skxPickTier; if (tiers[i]) { tier = i; render(); }
      }));
      render();

      /* add to cart */
      const hasDrawer = Cart.ensure(cfg, data);
      if (hasDrawer && cfg.useDrawer) document.querySelectorAll('[data-skx-cart-link]').forEach(a => {
        if (a.dataset.skxDrawer) return; a.dataset.skxDrawer = '1';
        a.addEventListener('click', e => { e.preventDefault(); Cart.open(); });
      });
      const msg = q('[data-skx-msg]');
      async function addToCart() {
        const v = variants[vIdx], qty = tiers.length ? +tiers[tier].dataset.qty : 1;
        msg.textContent = '';
        let items = [{ id: v.id, quantity: qty }];
        if (tiers.length && variants.length > 1 && units.length === qty) {
          const m = {}; units.forEach(k => { const id = variants[k].id; m[id] = (m[id] || 0) + 1; });
          items = Object.keys(m).map(id => ({ id: +id, quantity: m[id] }));
        }
        if (!hasDrawer || !cfg.useDrawer) {
          try { await Cart.add(items); location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; } catch (e) { msg.textContent = e.message; }
          return;
        }
        try { await Cart.add(items); await Cart.open(); }
        catch (e) { msg.textContent = e.message; }
      }
      q('[data-skx-atc]').addEventListener('click', addToCart);
      const sBtn = document.querySelector('[data-skx-sticky-btn]'); sBtn && sBtn.addEventListener('click', addToCart);

      /* free shipping (initial, from current cart) */
      setFreeShip(data.cartTotal || 0, cfg);

      /* sticky bar */
      const sticky = document.querySelector('.skx-sticky');
      if (sticky && 'IntersectionObserver' in window) {
        new IntersectionObserver(e => sticky.classList.toggle('show', !e[0].isIntersecting && e[0].boundingClientRect.top < 0)).observe(q('[data-skx-atc]'));
      }
    });
  }

  function initAll(root) { initCompare(root); initDimmer(root); initDots(root); initProduct(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
  else initAll(document);
  /* theme editor: re-init when sections are added or re-rendered */
  document.addEventListener('shopify:section:load', e => initAll(e.target));
})();
